




































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import SubscriptionsService from '@/services/subscriptions.service';

@Component({
  components: {},
})
export default class SigfoxPoolAddDrawer extends Vue {
  @Getter private login: any;
  @Prop() private sigfoxPool: any;
  @Prop() private hideDrawer: any;

  private isSaving: boolean = false;

  private async save() {
    this.isSaving = true;
    try {
      const response: any = await SubscriptionsService.createSigfoxSubscriptionPool(this.sigfoxPool);
      this.hideDrawer();
    } finally {
      this.isSaving = false;
    }
  }
}
